<template>
    <div id="filter-claims-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title capitalize">Filter Claims</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="message" class="alert alert-danger" role="alert">{{ message }}</div>
                    <div v-if="statusOptions.length" class="d-flex mt-2 mb-4">
                        <label for="statusFilter" class="my-auto flex-fill">Document Status</label>
                        <div class="flex-fill">
                            <select id="statusFilter" class="custom-select my-auto" :class="['mb-3', { 'text-muted' : selectedFilters.status_id === null }]" v-model="selectedFilters.status_id">
                                <option value="-1">Any</option>
                                <option v-for="option in statusOptions" :key="'document-type-' + option.id" :value="option.id" v-text="option.name"></option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <a href="javascript:void(0)" class="mr-auto" @click="reset">Reset Filters</a>
                    <button type="button" class="btn btn-primary" @click="done">Done</button>
                </div>
            </div>
        </div>
    </div>     
</template>

<script>
export default {
    data() {
        return {
            filter: Function,
            statusOptions: [],
            selectedFilters: {
                status_id: -1
            },            
            message: null            
        }
    },
    methods: {
        show: function (statusOptions, filters, callback) {
            this.statusOptions = statusOptions;
            this.selectedFilters = JSON.parse(JSON.stringify(filters));
            this.filter = callback;
            this.message = null;
            $('#filter-claims-modal').modal('show');
        },
        reset: function () {
            this.selectedFilters.status_id = -1;
            this.message = null;
        },
        done: function () { 
            // TODO: do validation here and set message if necessary           
            this.filter(this.selectedFilters);
            $('#filter-claims-modal').modal('hide');
        }
    },
    created() {
        eventHub.$on('show-claim-filters', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-claim-filters');
    },    
}
</script>

<style scoped>

</style>